const userTypes = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
    SIGN_UP_ERROR:'SIGN_UP_ERROR',
    REGISTER_SUCCESS:'REGISTER_SUCCESS',
    EMAIL_SIGN_IN_START:' EMAIL_SIGN_IN_START',
    SIGN_IN_SUCCESS:'SIGN_IN_SUCCESS',
    CHECK_USER_SESSION:'CHECK_USER_SESSION',
    SIGN_OUT_START:' SIGN_OUT_START',
    SIGN_OUT_SUCCESS:' SIGN_OUT_SUCCESS',
    SIGN_UP_START:'SIGN_UP_START',
    USER_ERROR: 'USER_ERROR',
    GOOGLE_SIGN_IN_START: ' GOOGLE_SIGN_IN_START'
};
export default userTypes